import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import role from './modules/role'
import breadcrumbs from './modules/breadcrumbs'
import selected_article from './modules/selected_article'
import frontstage_search from './modules/frontstage_search'

// initialize state

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    account,
    role,
    breadcrumbs,
    selected_article,
    frontstage_search,
  },
})
